export default __webpack_public_path__ + "static/media/mc_img.32c6fb2c.png";